module.exports = __webpack_public_path__ + "static/media/Cubic_Shaded.0d274ec4.svg";